import React from 'react';
import styles from '@/assets/styles/StudyCenter.module.less';
// import Summary from './Summary';
import LeftMenu from '../common/LeftMenu';
import UserInfo from '../common/UserInfo';
// import UserInfo, { useUserInfo } from '../common/UserInfo';
import { History } from './SearchHistory';

// TODO: 完成数据统计功能后改为显示学习统计页面
// const StudySummary: React.FC = () => {
//   const userInfo = useUserInfo();
//   return <Summary userId={userInfo.userId} userName={userInfo.name} />;
// }

const StudyCenter: React.FC = () => {

  return (
    <main className={styles.studyCenterContainer}>
      <LeftMenu />
      <UserInfo title="学习中心">
        {/* TODO: 完成数据统计功能后改为显示学习统计页面 */}
        <History />
      </UserInfo>
    </main>
  );
};

export default StudyCenter;
